/* Carrousel videos communaute - Maillot d'Or
   Boucle infinie : les vignettes sont recopiees autant de fois qu'il
   faut pour remplir l'ecran, et la piste se replace sans transition
   quand on approche d'un bord. Aucun trou, aucune fin.
   Une seule video chargee et jouee a la fois.
   01/10 (vitesse) : la premiere video attend la fin du chargement de
   la page (2,5 s au plus) et une video qui n'est plus au centre est
   dechargee, ce qui coupe son telechargement. Avant, plusieurs videos
   se telechargeaient en meme temps (jusqu'a 20 Mo des l'arrivee).
   Connexion lente ou economiseur de donnees : version 480p. */
(function () {
  'use strict';

  function demarrer(racine) {
    if (racine.dataset.mvcPret === '1') return;
    racine.dataset.mvcPret = '1';

    var piste = racine.querySelector('[data-mvc-piste]');
    var boite = racine.querySelector('[data-mvc-points]');
    if (!piste) return;

    var originaux = Array.prototype.slice.call(piste.querySelectorAll('.mvc-card'));
    var n = originaux.length;
    if (!n) return;

    var AUTO = racine.dataset.mvcAuto === '1';
    var DELAI = (parseInt(racine.dataset.mvcDelai, 10) || 15) * 1000;

    var cartes = originaux, jeux = 1, milieu = 0, boucle = false;
    var visible = false, actif = -1, tScroll = null, tAuto = null;
    var demarrage = true;
    var pagePrete = document.readyState === 'complete';

    function connexionLente() {
      var c = navigator.connection;
      return !!(c && (c.saveData || /(^|-)2g|3g/.test(c.effectiveType || '')));
    }

    function largeurJeu() {
      var st = getComputedStyle(piste);
      var g = parseFloat(st.columnGap || st.gap) || 0;
      return n * (originaux[0].getBoundingClientRect().width + g);
    }

    function cloner() {
      if (n < 2) return;
      var lj = largeurJeu();
      if (!lj) return;
      var voulu = Math.max(3, Math.ceil((piste.clientWidth * 3) / lj) + 2);
      if (voulu % 2 === 0) voulu += 1;
      var frag = document.createDocumentFragment();
      for (var j = 1; j < voulu; j++) {
        for (var i = 0; i < n; i++) {
          var c = originaux[i].cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          c.removeAttribute('id');
          frag.appendChild(c);
        }
      }
      piste.appendChild(frag);
      cartes = Array.prototype.slice.call(piste.querySelectorAll('.mvc-card'));
      jeux = voulu;
      milieu = Math.floor(voulu / 2);
      boucle = true;
      brancherCartes();
    }

    function pos(i) {
      var c = cartes[i];
      return c.offsetLeft + c.offsetWidth / 2 - piste.clientWidth / 2;
    }

    /* remise en place au demarrage : les polices et les images posters
       arrivent apres coup et le calage peut repartir a zero. */
    function placer() {
      if (!demarrage || actif < 0) return;
      piste.scrollLeft = pos(actif);
    }

    function lire(carte) {
      var v = carte.querySelector('video');
      if (!v || !pagePrete) return;
      if (!v.getAttribute('src')) {
        var src = (connexionLente() && v.dataset.srcLeger) ? v.dataset.srcLeger : v.dataset.src;
        if (!src) return;
        v.setAttribute('src', src);
        v.load();
      }
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () {});
    }

    /* pause + dechargement : sans src, le navigateur arrete de telecharger */
    function stopper(carte) {
      var v = carte.querySelector('video');
      if (!v) return;
      if (!v.paused) v.pause();
      if (v.getAttribute('src')) {
        v.removeAttribute('src');
        v.load();
      }
    }

    function pageChargee() {
      if (pagePrete) return;
      pagePrete = true;
      maj();
    }

    function relancer() {
      clearTimeout(tAuto);
      if (!AUTO || !visible || cartes.length < 2) return;
      tAuto = setTimeout(function () { aller(actif + 1); }, DELAI);
    }

    function aller(i) {
      demarrage = false;
      if (boucle) {
        if (i < 0) i += cartes.length;
        if (i >= cartes.length) i -= cartes.length;
      }
      if (i < 0 || i >= cartes.length) return;
      piste.scrollTo({ left: pos(i), behavior: 'smooth' });
      relancer();
    }

    function maj() {
      cartes.forEach(function (c, i) {
        c.classList.toggle('mvc-actif', i === actif);
        if (visible && i === actif) { lire(c); } else { stopper(c); }
      });
      if (boite) {
        var reel = actif < 0 ? 0 : actif % n;
        Array.prototype.forEach.call(boite.children, function (p, i) {
          p.classList.toggle('mvc-on', i === reel);
        });
      }
    }

    /* replace la piste au milieu, sans transition visible */
    function recentrer() {
      if (!boucle) return;
      if (actif >= n && actif < cartes.length - n) return;
      var cible = (actif % n) + n * milieu;
      if (cible === actif) return;
      var delta = pos(cible) - pos(actif);
      piste.classList.add('mvc-saute');
      piste.scrollLeft += delta;
      actif = cible;
      maj();
      requestAnimationFrame(function () { piste.classList.remove('mvc-saute'); });
    }

    function centre() {
      var r = piste.getBoundingClientRect();
      var cx = r.left + r.width / 2, best = 0, d = Infinity;
      cartes.forEach(function (c, i) {
        var cr = c.getBoundingClientRect();
        var dist = Math.abs(cr.left + cr.width / 2 - cx);
        if (dist < d) { d = dist; best = i; }
      });
      if (best !== actif) { actif = best; maj(); }
      recentrer();
    }

    piste.addEventListener('scroll', function () {
      clearTimeout(tScroll);
      tScroll = setTimeout(function () { centre(); relancer(); }, 90);
    }, { passive: true });

    /* glissement a la souris */
    var glisse = false, xDep = 0, gDep = 0, aBouge = false;

    piste.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      demarrage = false;
      glisse = true; aBouge = false;
      xDep = e.clientX; gDep = piste.scrollLeft;
      piste.classList.add('mvc-glisse');
      clearTimeout(tAuto);
    });

    piste.addEventListener('pointermove', function (e) {
      if (!glisse) return;
      var d = e.clientX - xDep;
      if (Math.abs(d) > 4) aBouge = true;
      piste.scrollLeft = gDep - d;
    });

    function finGlisse() {
      if (!glisse) return;
      glisse = false;
      piste.classList.remove('mvc-glisse');
      centre();
      aller(actif);
    }
    piste.addEventListener('pointerup', finGlisse);
    piste.addEventListener('pointercancel', finGlisse);
    piste.addEventListener('pointerleave', finGlisse);
    piste.addEventListener('touchstart', function () {
      demarrage = false;
      clearTimeout(tAuto);
    }, { passive: true });
    piste.addEventListener('wheel', function () { demarrage = false; }, { passive: true });

    /* clic sur une vignette voisine : elle vient au centre */
    function brancherCartes() {
      cartes.forEach(function (carte) {
        if (carte.dataset.mvcClic === '1') return;
        carte.dataset.mvcClic = '1';
        var media = carte.querySelector('.mvc-media');
        if (!media) return;
        media.addEventListener('click', function () {
          if (aBouge) { aBouge = false; return; }
          var i = cartes.indexOf(carte);
          if (i !== actif) aller(i);
        });
      });
    }

    /* pastilles : une par video reelle */
    if (boite) {
      for (var k = 0; k < n; k++) {
        (function (k) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'mvc-point';
          b.setAttribute('aria-label', 'Voir la video ' + (k + 1));
          b.addEventListener('click', function () {
            var base = actif - (actif % n);
            aller(base + k);
          });
          boite.appendChild(b);
        })(k);
      }
    }

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (e) {
        visible = e[0].isIntersecting;
        maj();
        if (visible) { relancer(); } else { clearTimeout(tAuto); }
      }, { threshold: 0.15 }).observe(racine);
    } else {
      visible = true;
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { clearTimeout(tAuto); cartes.forEach(stopper); }
      else { maj(); relancer(); }
    });

    var largeurEcran = window.innerWidth;
    window.addEventListener('resize', function () {
      if (Math.abs(window.innerWidth - largeurEcran) < 60) return;
      largeurEcran = window.innerWidth;
      if (actif >= 0) piste.scrollLeft = pos(actif);
    }, { passive: true });

    if (!pagePrete) {
      window.addEventListener('load', pageChargee, { once: true });
      setTimeout(pageChargee, 2500);
    }

    brancherCartes();
    cloner();
    actif = boucle ? n * milieu : Math.floor(n / 2);
    maj();
    requestAnimationFrame(placer);
    setTimeout(placer, 120);
    setTimeout(placer, 400);
    setTimeout(function () { placer(); demarrage = false; }, 900);
    window.addEventListener('load', placer, { once: true });
  }

  function tout() {
    document.querySelectorAll('.mvc[data-mvc-auto]').forEach(demarrer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tout);
  } else {
    tout();
  }
  document.addEventListener('shopify:section:load', tout);
})();
